import css from './loading.module.css';

const Loading = () => (<div className={css.Loading}>. . .</div>);

export default Loading;
